import { NavLink, Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { resolveStudentIdentity } from "@/lib/profile";
import { studentMenu } from "@/data/panels";
import {useSiteSettingsContext} from "@/hooks/useSiteSettingsContext";

export default function Sidebar() {
  const { user } = useAuth();
  const identity = resolveStudentIdentity(user);
  const roleLabel = identity.grade ? `${identity.grade} Öğrencisi` : "Öğrenci";
  const { settings } = useSiteSettingsContext();
  const name = settings.siteName || "Dersdinle";

  return (
    <aside className="hidden lg:flex fixed top-0 left-0 bottom-0 w-64 bg-background-50 border-r border-background-200 z-40 flex-col">
      {/* Logo */}
      <Link
        to="/"
        className="flex items-center gap-2.5 h-16 px-5 border-b border-background-200 shrink-0"
      >
        <img
          src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/701ba01ffa472e24f05c5cced92a417f.png"
          alt={name}
          className="h-9 w-auto object-contain"
        />
      </Link>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto py-3 px-3">
        {studentMenu.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            end={item.href === "/ogrenci"}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium mb-0.5 transition-colors ${
                isActive
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
              }`
            }
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className={`${item.icon} text-base`} aria-hidden="true"></i>
            </span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Bottom: user */}
      <div className="border-t border-background-200 p-4 shrink-0">
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-heading font-semibold text-sm">
            {identity.initials}
          </span>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground-950 truncate">{identity.name}</p>
            <p className="text-xs text-foreground-500 truncate">{roleLabel}</p>
          </div>
        </div>
      </div>
    </aside>
  );
}